import { isNotEmptyElement } from '@feedyou/utils'
import { DialogId, CaseSchema, SwitchStepSchema } from '@feedyou/schema'

import { GetUsedDialogs } from '../../../types'

export const getUsedDialogs: GetUsedDialogs<SwitchStepSchema> = (step, enabledOnly = false) => {
  if (enabledOnly && step.disabled) {
    return []
  }

  const usedInCases =
    step.cases?.flatMap(switchCase => getUsedDialogsForSwitchCase(switchCase, enabledOnly)) ?? []

  return [step.default?.dialog, ...usedInCases].filter(isNotEmptyElement)
}

const getUsedDialogsForSwitchCase = (switchCase: CaseSchema, enabledOnly: boolean): DialogId[] => {
  if (switchCase.disabled && enabledOnly) {
    return []
  }

  return switchCase.dialog ? [switchCase.dialog] : []
}
